import { render, staticRenderFns } from "./urkunde_page_a4.vue?vue&type=template&id=ee7344a0&scoped=true"
import script from "./urkunde_page_a4.vue?vue&type=script&lang=js"
export * from "./urkunde_page_a4.vue?vue&type=script&lang=js"
import style0 from "./urkunde_page_a4.vue?vue&type=style&index=0&id=ee7344a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7344a0",
  null
  
)

export default component.exports